// extracted by mini-css-extract-plugin
module.exports = {"label":"ArtistEditorFooterLabel-label-1BBnQ","savingIcon":"ArtistEditorFooterLabel-savingIcon-32x8j"};